/**
 * Navegación del panel «Campañas» cuando la API soporta la fase 1 (ver `metaFase1Support.js`).
 * Paso 2 del refactor UI/UX: sin pestañas. El panel es la lista de campañas y Análisis e Informe
 * son subvistas que se abren desde el encabezado («CAMPAÑAS / ANÁLISIS», «CAMPAÑAS / INFORME»).
 * La vista global de Presupuesto ya no existe: su resumen va en el Informe y el de cada campaña,
 * en su detalle.
 */

// `actionLabel` (t1055u): Tooltip y aria-label del ícono en el encabezado de Campañas. «general»
// porque abren todo el espacio (Análisis con «Todas las campañas» por defecto), no la campaña
// elegida (esa tiene su pestaña Análisis y su «Informe de la unidad» en la tarjeta).
export const META_SUBVIEWS = [
  { key: 'analysis', label: 'Análisis', actionLabel: 'Análisis general', title: 'ANÁLISIS' },
  { key: 'report', label: 'Informe', actionLabel: 'Informe general', title: 'INFORME' },
];

export const META_ANALYSIS_TABS = [
  { key: 'audience', label: 'Público' },
  { key: 'platforms', label: 'Plataformas' },
  { key: 'interactions', label: 'Interacciones' },
];

export const META_DEFAULT_ANALYSIS_TAB = 'audience';

const isKey = (list, key) => list.some((it) => it.key === key);
export const isMetaSubview = (key) => isKey(META_SUBVIEWS, key);
export const isMetaAnalysisTab = (key) => isKey(META_ANALYSIS_TABS, key);

/**
 * Subtítulo del header de una subvista (Campañas lo arma el panel según el permiso de vincular).
 * Análisis cambia según la dimensión elegida.
 */
export function metaSectionSubtitle(section, analysisTab) {
  if (section === 'analysis') {
    return {
      audience: 'Quién respondió a tus anuncios (solo informativo).',
      platforms: 'Dónde se mostraron tus anuncios.',
      interactions: 'Cómo reaccionó la gente a tus anuncios.',
    }[analysisTab] || '';
  }
  return {
    report: 'Resultados de tus anuncios para compartir o archivar.',
  }[section] || '';
}
